import { render, staticRenderFns } from "./ConfigDashboard.vue?vue&type=template&id=023bb573&scoped=true"
import script from "./ConfigDashboard.vue?vue&type=script&lang=js"
export * from "./ConfigDashboard.vue?vue&type=script&lang=js"
import style0 from "./ConfigDashboard.vue?vue&type=style&index=0&id=023bb573&prod&scoped=true&lang=css"
import style1 from "./ConfigDashboard.vue?vue&type=style&index=1&id=023bb573&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023bb573",
  null
  
)

export default component.exports